import env from '@core/env-config';

const documentsUrl = env.DOCUMENTS_URL;

export const PRE_SALE_INFO_PDF = `${documentsUrl}/PreSaleInfo.pdf`;
export const POLICY_AGREEMENT_PDF = `${documentsUrl}/PolicyAgreement.pdf`;
export const PRODUCT_FACT_PDF = `${documentsUrl}/ProductFact.pdf`;
